import React, { Component } from 'react';
import { Card, Button } from 'semantic-ui-react';
import { withApollo, compose } from 'react-apollo';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as messageActions from '../../actions/message-actions';

import { ScanPassengerTicket } from '../../mutations/ScanPassengerTicket';
import { DestroyPassengerTicket } from '../../mutations/DestroyPassengerTicket';
import RedirectWithFilters from '../RedirectWithFilters';

class ButtonsBlock extends Component {
  state = {};

  handleScan = () => {
    const {
      match,
      onTicketUpdated,
      hideLoading,
      showLoading,
      client,
      actions
    } = this.props;
    showLoading();
    client
      .mutate({
        mutation: ScanPassengerTicket,
        variables: {
          input: {
            id: match.params.id
          }
        }
      })
      .then(({ data }) => {
        hideLoading();
        const claims = _.get(
          data,
          'scanPassengerTicket.passengerTicket.claimsConnection.edges',
          []
        );
        actions.showMessage({
          header: 'Passenger ticket rescanned successfully',
          text: `Number of claims for this ticket: ${claims.length}`,
          props: { success: true },
          duration: 4000
        });
        onTicketUpdated();
      })
      .catch(() => hideLoading());
  };

  handleEdit = () =>
    this.props.history.push(`/ticket/edit/${this.props.match.params.id}`);

  handleCancel = () => this.props.history.goBack();

  handleRemove = () => {
    const {
      match,
      hideLoading,
      showLoading,
      client,
      actions
    } = this.props;
    showLoading();
    client
      .mutate({
        mutation: DestroyPassengerTicket,
        variables: {
          input: {
            id: match.params.id
          }
        }
      })
      .then(({ data }) => {
        hideLoading();
        actions.showMessage({
          header: 'Ticket removed',
          text: 'The ticket has been successfully removed!',
          props: { success: true },
          duration: 2000
        });
        this.setState({ redirect: true });
      })
      .catch(() => hideLoading());
  };
  render() {
    const { redirect } = this.state;
    const { isAnonymized } = this.props;
    if (redirect) return <RedirectWithFilters to="tickets" />;
    return (
      <Card.Content extra>
        <Button
          primary
          disabled={isAnonymized}
          onClick={this.handleScan}
          content="Scan"
        />
        <Button primary onClick={this.handleEdit} content="Edit" />
        <Button primary onClick={this.handleRemove} content="Remove" />
        <Button primary basic onClick={this.handleCancel} content="Cancel" />
      </Card.Content>
    );
  }
}

export default compose(
  withApollo,
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(messageActions, dispatch)
    })
  )
)(ButtonsBlock);



// WEBPACK FOOTER //
// ./src/component/TicketPage/ButtonsBlock.js